import { makeAutoObservable } from 'mobx';

export type Breadcrumb = {
  url: string,
  title: string,
};

export class BreadcrumbStore {
  private crumbs: Breadcrumb[] = [];

  constructor() {
    makeAutoObservable(this);
  }

  set breadcrumbs(crumbs: Breadcrumb[]) {
    this.crumbs = crumbs;
  }

  get breadcrumbs() {
    return this.crumbs;
  }
}
